import { useEffect } from "react";
import { startPppcInstallPoller } from "@/services/pppcInstallPoller";

/**
 * Mounts the global PPPC install poller for the lifetime of the app.
 *
 * Renders nothing. Lives at the App root so the timeline and Logs page
 * receive "installed" entries promptly even when no device detail page
 * is open. See `pppcInstallPoller.ts` for the polling strategy and the
 * dedup contract that keeps repeated polls from spamming the audit log.
 */
export default function PppcInstallPollerMount() {
  useEffect(() => {
    const poller = startPppcInstallPoller();
    return () => poller.stop();
  }, []);
  return null;
}
